import React from "react";
import { Container } from "react-bootstrap";

export const GiftCards: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Gift Cards
            </Container>
        </React.Fragment>
    );
}